import { 
  // Status Circulares
  Circle,
  // Produtos e Serviços
  Smartphone,
  Phone,
  HardDrive,
  Tablet,
  Wifi,
  Cloud,
  // Ações e Estados
  CheckCircle2,
  AlertTriangle,
  XCircle,
  Check,
  TrendingUp,
  RefreshCw,
  // Pessoas e Locais
  MapPin,
  FileText,
  User,
  Building2,
  // Comunicação
  Radio,
  RadioTower,
  Clock,
  CheckCheck,
  // Outros
  DollarSign,
  Package,
  Calendar,
  Loader2,
  Rocket,
  Briefcase,
  Gauge
} from "lucide-react";

export const AppIcons = {
  // ============================================
  // 📍 INFORMAÇÕES DE CONTATO/LOCALIZAÇÃO
  // ============================================
  endereco: MapPin,
  plano: FileText,
  telefone: Smartphone,
  cessionario: User,
  gestor: Building2,
  velocidade: Gauge,
  
  // ============================================
  // 🎯 STATUS DE PEDIDOS (Quadros)
  // ============================================
  statusComercial: Circle,
  statusContratoPrime: Circle,
  statusTramitacaoVivo: Circle,
  statusTramitacaoPrime: Circle,
  statusQualidade: Circle,
  statusCancelado: Circle,
  statusDefault: Circle,
  
  // ============================================
  // 📦 FAMÍLIA DE PRODUTOS
  // ============================================
  familiaMovel: Smartphone,
  familiaFixa: Phone,
  familiaDados: HardDrive,
  familiaAparelho: Tablet,
  familiaFibra: Wifi,
  
  // ============================================
  // 💰 TIPO DE FATURAMENTO
  // ============================================
  vendaNova: TrendingUp,
  migracao: RefreshCw,
  
  // ============================================
  // ✅ STATUS DE VALIDAÇÃO
  // ============================================
  sucesso: CheckCircle2,
  aviso: AlertTriangle,
  erro: XCircle,
  check: Check,
  checkDuplo: CheckCheck,
  
  // ============================================
  // 📡 STATUS DE CONEXÃO REALTIME
  // ============================================
  aoVivo: Radio,
  offline: RadioTower,
  conectando: Loader2,
  
  // ============================================
  // ⏱️ STATUS DE MENSAGENS
  // ============================================
  mensagemPendente: Clock,
  mensagemEnviada: Check,
  mensagemEntregue: CheckCheck,
  mensagemLida: CheckCheck,
  mensagemErro: XCircle,
  
  // ============================================
  // 📊 MÉTRICAS E KPIs
  // ============================================
  crescimento: TrendingUp,
  performance: Rocket,
  valor: DollarSign,
  produto: Package,
  negocios: Briefcase,
  
  // ============================================
  // 📅 TEMPORAIS
  // ============================================
  calendario: Calendar,
  relogio: Clock,
  
  // ============================================
  // ☁️ GERAL
  // ============================================
  cloudServer: Cloud,
  internet: Wifi,
  documento: FileText,
};

// ============================================
// 🎨 TAMANHOS PADRÃO
// ============================================
export const IconSizes = {
  xs: "h-3 w-3",
  sm: "h-4 w-4",
  md: "h-5 w-5",
  lg: "h-6 w-6",
  xl: "h-8 w-8",
};

// ============================================
// 🌈 CORES PADRÃO PARA STATUS
// ============================================
export const IconColors = {
  // Quadros
  comercial: "text-info dark:text-info",
  contratoPrime: "text-warning dark:text-warning",
  tramitacaoVivo: "text-warning dark:text-warning",
  tramitacaoPrime: "text-purple-600 dark:text-purple-400",
  qualidade: "text-success dark:text-success",
  cancelado: "text-danger dark:text-danger",
  
  // Estados
  sucesso: "text-success dark:text-success",
  aviso: "text-warning dark:text-warning",
  erro: "text-danger dark:text-danger",
  info: "text-info dark:text-info",
  muted: "text-muted-foreground",
  
  // Família de produtos
  movel: "text-purple-600 dark:text-purple-400",
  fixa: "text-info dark:text-info",
  dados: "text-info dark:text-info",
  aparelho: "text-gray-600 dark:text-gray-400",
  fibra: "text-success dark:text-success",
};

// ============================================
// 🎯 HELPER: Retornar ícone + cor de status de quadro
// ============================================
export function getQuadroIcon(quadro: string) {
  const map: Record<string, { icon: typeof Circle; color: string }> = {
    'COMERCIAL': { icon: AppIcons.statusComercial, color: IconColors.comercial },
    'CONTRATO_PRIME': { icon: AppIcons.statusContratoPrime, color: IconColors.contratoPrime },
    'TRAMITACAO_VIVO': { icon: AppIcons.statusTramitacaoVivo, color: IconColors.tramitacaoVivo },
    'TRAMITACAO_PRIME': { icon: AppIcons.statusTramitacaoPrime, color: IconColors.tramitacaoPrime },
    'QUALIDADE': { icon: AppIcons.statusQualidade, color: IconColors.qualidade },
    'PEDIDO_CANCELADO': { icon: AppIcons.statusCancelado, color: IconColors.cancelado },
  };
  return map[quadro] || { icon: AppIcons.statusDefault, color: IconColors.muted };
}

// ============================================
// 🎯 HELPER: Retornar ícone + cor de família
// ============================================
export function getFamiliaIcon(familia: string) {
  const map: Record<string, { icon: any; color: string }> = {
    'MOVEL': { icon: AppIcons.familiaMovel, color: IconColors.movel },
    'FIXA': { icon: AppIcons.familiaFixa, color: IconColors.fixa },
    'DADOS': { icon: AppIcons.familiaDados, color: IconColors.dados },
    'APARELHO': { icon: AppIcons.familiaAparelho, color: IconColors.aparelho },
    'FIBRA': { icon: AppIcons.familiaFibra, color: IconColors.fibra },
  };
  return map[familia] || { icon: AppIcons.produto, color: IconColors.muted };
}
